import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/auth.service';
import { SidebarService } from 'src/home/sidebar.service';
import { UsersService } from 'src/home/users/services/users.service';
import { ChangePasswordModalComponent } from 'src/home/users/user-change-password-modal/change-password-modal.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  isSidebarActive: boolean = false;
  userInfo: any;
  isLoading: boolean = false;
  userRole: string = '';
  public rolesMap: any = {
    ROLE_CONSULTANT: 'Consultor',
    ROLE_ADMIN: 'Administrador',
    ROLE_CRM: 'Usuario de CRM',
  };
  constructor(
    public sidebarService: SidebarService,
    private usersService: UsersService,
    private authService: AuthService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // this.handleGetUserInfo();
    this.userRole = this.authService.getCurrentUserRole();
    this.userInfo = localStorage.getItem('email') || '';
  }

  toggleSidenav(): void {
    this.sidebarService.toggleSidebar();

    if (window.innerWidth < 768) {
      this.isSidebarActive = !this.isSidebarActive;
    }
  }
  handleGetUserInfo(): void {
    this.isLoading = true;
    this.usersService.getUserInfo().subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data && data.role) {
          data.role = this.formatRole(data.role);
        }
        this.userInfo = data;
      },
      (error: any) => {
        console.error('Error fetching user info:', error);
        this.isLoading = false;
      }
    );
  }
  formatRole(role: string): string {
    return this.rolesMap[role] || role;
  }
  openUserFormModal(): void {
    const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: {
        title: 'Usuario',
        email: this.userInfo.email,
      },
    });
  }
  handleLogout(): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Quieres cerrar sesión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FFA500',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, cerrar sesión',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

}
